import React from "react";
import { useTranslation } from "react-i18next";
import {
  StyledModalBody,
  StyledModal,
  StyledModalFooter,
} from "../styledComponents/StyledModals";
import { StyledButton } from "../styledComponents/CommonStyledComponents";
import { MUTATION_ACCEPT_ROLLING_DEPOSIT_LIMIT } from "../graphql/mutations";
import { useApolloClient } from "@apollo/client";

const ROLLING_PERIOD_BY_CURRENT = {
  daily: "24 hours",
  weekly: "7 days",
  monthly: "30 days",
};

const periodFromLimitType = (limitType = "") => {
  const raw = String(limitType).toLowerCase();
  if (
    raw.startsWith("weekly") ||
    raw.startsWith("7day") ||
    raw.startsWith("7days")
  ) {
    return "weekly";
  }
  if (
    raw.startsWith("monthly") ||
    raw.startsWith("30day") ||
    raw.startsWith("30days")
  ) {
    return "monthly";
  }
  return "daily";
};

export const RollingLimitsDialog = ({
  skin,
  pages,
  currency,
  showRollingLimitsDialog,
  onAcknowledge,
}) => {
  const { t } = useTranslation("");
  const apolloClient = useApolloClient();

  const amount =
    showRollingLimitsDialog && showRollingLimitsDialog.initialAmount != null
      ? showRollingLimitsDialog.initialAmount / 100
      : "";
  const currentPeriod = periodFromLimitType(
    showRollingLimitsDialog && showRollingLimitsDialog.limitType,
  );
  const rollingPeriod = ROLLING_PERIOD_BY_CURRENT[currentPeriod];

  const acceptNettLimit = async () => {
    // TODO: call BE ack mutation when endpoint is available
    const response = await apolloClient.mutate({
      mutation: MUTATION_ACCEPT_ROLLING_DEPOSIT_LIMIT,
      variables: { limitRegime: "nett" },
    });
    return response?.data?.setRollingDepositLimit?.ok;
  };

  const handleAcknowledge = async () => {
    try {
      if (await acceptNettLimit()) {
        window.location.reload();
      }
    } catch (error) {
      console.log("error accepting rolling deposit limit", error);
    }
  };

  const handleBodyClick = async (e) => {
    const link = e.target.closest("a");
    if (!link) return;
    e.preventDefault();
    try {
      if (await acceptNettLimit()) {
        window.location.replace((pages && pages["my-limits"]) || link.href);
      }
    } catch (error) {
      console.log("error accepting rolling deposit limit", error);
    }
  };

  return (
    <StyledModal
      isOpen={showRollingLimitsDialog && showRollingLimitsDialog.displayPopup}
    >
      <StyledModalBody
        register
        rollingLimits
        onClick={handleBodyClick}
        dangerouslySetInnerHTML={{
          __html: t("label_rolling_limits", {
            currency: currency || "",
            amount,
            period: currentPeriod,
            rollingPeriod,
            limitsUrl: (pages && pages["my-limits"]) || "",
            /*  defaultValue:
              "<h3>Your limits will be converted to rolling limits</h3>" +
              "<div>Your current deposit limit is: {{amount}} {{period}}</div>" +
              "<div>After you click on OK, your new rolling limit will be: {{amount}} for {{rollingPeriod}}</div>" +
              '<div>You can now switch between nett and gross deposit limits on <a href="{{limitsUrl}}">Limits</a>.</div>', */
          }),
        }}
      ></StyledModalBody>
      <StyledModalFooter position>
        <StyledButton
          banktransfer
          pub={skin === "pub"}
          onClick={handleAcknowledge}
        >
          {t("label_understood", "Ok")}
        </StyledButton>
      </StyledModalFooter>
    </StyledModal>
  );
};
